import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';

import { Month, MonthPicker } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderContinuationFormBeanPart,
   MedicalDeviceOrderFirstSupplyMonthFormBeanPart,
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormSetValue,
   MedicalDeviceOrderFormWatch,
} from '../medicalDeviceOrder.types';

type FirstSupplyMonthFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<
      MedicalDeviceOrderFirstSupplyMonthFormBeanPart & MedicalDeviceOrderContinuationFormBeanPart
   >;
   readonly setValue: MedicalDeviceOrderFormSetValue;
   readonly watch: MedicalDeviceOrderFormWatch;
};

export const FirstSupplyMonthField = (props: FirstSupplyMonthFieldProps): JSX.Element => {
   const continuationChecked = props.watch('continuation');
   const controller = props.register('firstSupplyMonth', { required: true });
   useUpdateEffect(() => {
      // Business requirement - change field value only when user did not change firstSupplyMonth intentionally
      if (controller.control?.formState.dirtyFields.firstSupplyMonth) {
         return;
      }
      const nextMonthDate = new Date();
      nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
      props.setValue('firstSupplyMonth', continuationChecked ? nextMonthDate : new Date());
   }, [continuationChecked]);

   const availableSupplyMonths = useMemo(() => {
      const nextMonthDate = new Date();
      const nextMonthDateMonth = nextMonthDate.getMonth();
      if (nextMonthDateMonth === Month.DECEMBER) {
         nextMonthDate.setMonth(Month.JANUARY);
         nextMonthDate.setFullYear(nextMonthDate.getFullYear() + 1);
      } else {
         nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
      }
      return [new Date(), nextMonthDate];
   }, []);

   return (
      <MonthPicker
         testId={'firstSupplyMonth'}
         controller={controller}
         label={medicalDevicesTranslationKeys.fields.firstSupplyMonth}
         defaultValue={new Date()}
         enabledMonths={availableSupplyMonths}
         disableInput
      />
   );
};
